import { store } from "../store/index";
import {
  filterMeeting,
  get,
  createMeeting,
  update,
  removeMeeting,
  filterMeetingAll,
  listMeetingToExport,
} from "../store/actions/MeetingActions";

/**
 * Create Meeting
 */
export const addMeeting = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createMeeting(objSend));
  if (result?.payload?.data) {
    return "OK";
  }
  return null;
};

/**
 * Get Meeting
 */
export const getMeeting = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(get(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Meeting
 */
export const updateMeeting = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(update(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Meeting
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterMeeting(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List Meeting
 */
export const listFilterAll = async (filter) => {
  const result = await store.dispatch(filterMeetingAll(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Meeting
 */
export const deleteMeeting = async (uuid) => {
  const result = await store.dispatch(removeMeeting([uuid]));
  if (result?.payload) {
    return result.payload;
  }
  return null;
};

export const listToExport = async (filter) => {
  const result = await store.dispatch(listMeetingToExport(filter));
  if (result && result.payload && result.payload) {
    return result.payload;
  }
  return null;
};
